/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        13/02/2020      2573: API Error when selecting a facility
CHID-2     Mahesh        28/02/2020      2693: Facility Screen - Distance
*********************************************************************************/
import { Component } from "@mna/react";
import FullScreenMap from "../Map/FullScreen";
import ClinicsCarousel from "./Carousel";
import ClinicModalProvider from "./ModalProvider";
import { telemedicineVendors, careOptions } from "../../server/triage/constants";
import { checkAndGetLocalStorageValue, checkAndGetSessionStorageValue } from "../utils";

//CHID-1  Start
function AddLocationToLogCallback(state, history, actions) {
  state.selectedOption = "";
  state.triageRequest.vendorName =
    state.triageResponse.vendorsList &&
    state.triageResponse.vendorsList[0] &&
    state.triageResponse.vendorsList[0].nameLocalization.localizations[0].value;
  if (
    localStorage.getItem("careoption") === "Telemedicine" &&
    state.triageRequest.vendorName == telemedicineVendors.oneEightHundredMD
  ) {
    history.push(`/find-care-options/telemed-confirm-screen`);
  }
  else {
    if (checkAndGetSessionStorageValue("IsValidUser") === "true" || checkAndGetSessionStorageValue("isFacility") === "true" || checkAndGetSessionStorageValue("isTravelAid2") === "true") {
      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
      if(state.isFacility || state.triageRequest.isFacilitySearch){
       if(state.triageRequest.data && state.triageRequest.data.email === "" || state.triageRequest.data === undefined) {
        sessionStorage.setItem("EmailField", false);
        sessionStorage.setItem("EmailValidate", "true")
      }else{
        sessionStorage.setItem("EmailField", true);
      }
      if(state.triageRequest.data && state.triageRequest.data.phone === "" || state.triageRequest.data === undefined){
        sessionStorage.setItem("phoneField", false);
      }else{
        sessionStorage.setItem("phoneField", true);
      }
    }
      history.push(`/find-care-options/send-information`);
    }
    else {
      gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
      actions.updatePatientContactForClinics();
      history.push(`/find-care-options/done`);
    }

  }
} //CHID-1  End
export default class Clinics extends Component {
  componentDidMount() {
    const { state, actions } = this.props
    const container = document.getElementsByClassName('carousel-track');
    if (container && container.length > 0)
    {
      const collection = document.getElementsByClassName('carousel-card')
      const myElements = Array.from(collection);

      container[0].setAttribute('role', 'list');
      container[0].setAttribute('aria-label', 'List of ' + (myElements ? myElements.length : 0))

      myElements.forEach((element, index) => {
        if(!element.hasAttribute('role')){
          element.setAttribute('role','listitem');
        }
        if(!element.hasAttribute('aria-label')){
          element.setAttribute('aria-label', (index + 1) + ' of ' + (myElements ? myElements.length : 0));
        }
      });
    }
  };
  getDirections = ({ index, clinic }) => {
    const { latitude: toLatitude, longitude: toLongitude } = clinic || {};

    const {
      triageRequest: {
        locationMeta: {
          latitude: fromLatitude = 0,
          longitude: fromLongitude = 0,
        },
      },
    } = this.props.state;

    // https://developers.google.com/maps/documentation/javascript/directions
    const { google, map } = this;

    if (!google || !map) {
      console.log("getDirections failed - no google or map", {
        index,
        clinic,
        google,
        map,
      });
      return;
    }

    const start = new google.maps.LatLng(fromLatitude, fromLongitude);
    const end = new google.maps.LatLng(toLatitude, toLongitude);

    // Create GoogleMaps directions display and service once

    if (!this.directionsDisplay) {
      // Map should be already initialized
      // Constructor can also get "DirectionsRendererOptions" object
      this.directionsDisplay = new google.maps.DirectionsRenderer();
      this.directionsDisplay.setMap(map);
    }

    if (!this.directionsService) {
      this.directionsService = new google.maps.DirectionsService();
    }

    const request = {
      origin: start,
      destination: end,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    console.log("getDirections", {
      fromLatitude,
      fromLongitude,
      toLatitude,
      toLongitude,
      start,
      end,
    });

    this.directionsService.route(request, (response, status) => {
      if (status != google.maps.DirectionsStatus.OK) {
        console.log("getDirections fail", { response, status });
        return;
      }

      this.directionsDisplay.setDirections(response);

      console.log("getDirections success", response);
    });
  };

  sendInformation = ({ index, clinic }) => {
    const { actions, history } = this.props;
    console.log("sendInformation", { index, clinic, actions, history });

    actions.setTriageRequest({
      selectedProvider: clinic,
    });
    actions.submitTriageFacility();
    actions.AddingLocationToLog({ AddLocationToLogCallback, clinic, history });
    if (localStorage.getItem("careoption") == "Telemedicine") {
      actions.updateLogPharmaciesData({ clinic });
    }
    else if (localStorage.getItem("careoption") !== careOptions.Telemedicine
      || localStorage.getItem("careoption") !== careOptions.HouseVisit
      || localStorage.getItem("careoption") !== careOptions.ConciergeCare) {
      actions.AddingFacilityContact({ clinic, history });
    }
  };
  updateLogPharmaciesData = ({ index, clinic }) => {
    const { actions, history } = this.props;
    console.log("sendInformation", { index, clinic, actions, history });

    actions.setTriageRequest({
      selectedProvider: clinic,
    });
    if (localStorage.getItem("careoption") == careOptions.MedicalFacility || localStorage.getItem("careoption") == careOptions.Clinic) {
      actions.AddingLocationToLog({ clinic, history });
      actions.submitTriageFacility();
      actions.AddingFacilityContact({ clinic, history });
    }
    else {
      actions.updateLogTelemedContactDetails({ clinic });
      actions.updateLogPharmaciesData({ clinic });
    }
  };

  render() {
    const { markers = [], clinics = [], header, actions, history, state } = this.props;
    return (
      <ClinicModalProvider
        clinics={clinics}
        actions={{
          getDirections: this.getDirections,
          sendInformation: this.sendInformation,
          updateLogPharmaciesData: this.updateLogPharmaciesData,
          next: this.next,
        }}
        history={history}
        state={state}
      >
        {({ openModal }) => (
          <FullScreenMap
            onMapMounted={({ google, map }) => {
              this.google = google;
              this.map = map;
            }}
            header={header}
            markers={markers}
            onMarkerClick={({ index }) => {
              openModal({ currentItem: index });
              this.carousel && this.carousel.go(clinics.length - index);
            }}
            footer={
              <ClinicsCarousel
                clinics={clinics}
                onCardClick={({ index }) => {
                  openModal({ currentItem: index });
                  this.getDirections({ index, clinic: clinics[index] });
                }}
                //CHID-2
                onChange={(index) => {
                  this.getDirections({ index, clinic: clinics[index] });
                }}
                //CHID-2
                getInstance={(carousel) => (this.carousel = carousel)}
              />
            }
          />
        )}
      </ClinicModalProvider>
    );
  }
}
